/**
 * Created by pmnia on 10/31/15.
 */
(function(){
    angular.module('app.widgets')
        .directive('obtSection', obtSection);

    function obtSection(){
        return {
            priority: 50,
            restrict:'E',
            scope:{
                pageSectionId:'@?',
                pageId:'@?',
                data:'=?data',
                type:'@?',
                templateUrl:'@?',
                anchor:'@?'
            },
            bindToController:true,
            controllerAs:'vm',
            template:'<div ng-class="vm.data.css" ng-include="vm.getContentUrl()" id="anchor{{vm.anchor}}"></div>',
            controller:/*@ngInject*/function(screenSize, Lightbox, ngCart,$sce,sessionServices,$rootScope,Carousel){
                var vm = this;
                active();
                vm.getConnectedState= getConnectedState;
                vm.getContentUrl = getContentUrl;
                vm.getIdItem = getIdItem;
                vm.ngCart = ngCart;
                vm.items = [] ;
                vm.galtype9 = [] ;
                vm.galtype7 = [] ;
                vm.galtype9Mobile = [];
                vm.galtype7Mobile = [];
                vm.desktop = screenSize.is('md, lg');
                vm.mobile = screenSize.is('xs, sm');
                vm.angular =  angular;
                vm.getCartDirective = function (){
                   var data = {};
                    data.items = [] ;
                    data.items = vm.ngCart.getCart().items ;
                    data.shipping = vm.ngCart.getCart().shipping;
                    data.tax = vm.ngCart.getCart().tax ;
                    data.taxRate= vm.ngCart.getCart().taxRate ;
                    data.totalCost = vm.ngCart.totalCost();
                    data.SubTotal=  vm.ngCart.getSubTotal();
                    return data ;
                }
                // Using dynamic method `on`, which will set the variables initially and then update the variable on window resize
    vm.desktop = screenSize.on('md, lg', function(match){
        vm.desktop = match;
    });
    vm.mobile = screenSize.on('xs, sm', function(match){
        vm.mobile = match;
       })




                vm.trustSrc = function(src) {
                    src = src+'?rel=0&autoplay=1&version=3&loop=1&controls=0&modestbranding=1&showinfo=0';
                    if(src.includes('vimeo')){
                        src = src+'&byline=0&portrait=0&background=1' ;
                    }
                    return $sce.trustAsResourceUrl(src);
                }


                function active(){

                    if(vm.type && vm.type === '7'){
                        if(vm.data.gallery && Array.isArray(vm.data.gallery)){
                            vm.data.gallery = vm.data.gallery.map(function (item) {
                                item.titleDisplayImage = vm.data.TitleDisplayImage;
                                item.DescriptionDisplayImage = vm.data.DescriptionDisplayImage;
                                return item;
                            });
                        }

                    }
                }

                function getConnectedState(){
                   return sessionServices.getArgs('isLogged');

                }
                vm.openlightBoxCarousel = function (data,index){
                  console.log(data,index)

                    Lightbox.openModal(data,index);

                }
    vm.openLightboxModal = function (arg,anchor){
                var tampon = [] ;
                var items = $rootScope.pageSection ;
                      angular.forEach(items , function (value){
                                if(value.anchor === anchor){
                                      if(value.data.gallery && value.data.gallery.length){
                                        console.log( vm.data.TitleDisplayImage);
                                        console.log(vm.data.DescriptionDisplayImage);
                                         tampon = value.data.gallery ;
                                             angular.forEach(tampon,function (values,key){
                                                values.titleDisplayImage = vm.data.TitleDisplayImage;
                                                values.DescriptionDisplayImage = vm.data.DescriptionDisplayImage;
                                                    if(values.thumbUrl === arg.thumbUrl && values.title === arg.title){
                                                      
                                                         console.log(tampon,'mon tampon');                                                      
                                                        Lightbox.openModal(tampon, key);
                                                       }
                                             })

                                       }
                                }

                     })
    }


       function getIdItem (arg,anchor){
            var id = '' ;
         if(vm.type && vm.type === '9'){
           var items = $rootScope.pageSection ;
                      angular.forEach(items , function (value){
                           if(value.anchor === anchor){
                                if(value.data.gallery && value.data.gallery.length){
                                    tampon = value.data.gallery ;
                                    angular.forEach(tampon,function (values,key){
                                        if(values.thumbUrl === arg.thumbUrl && values.title === arg.title){
                                           id =(key+1).toString();
                                           id = 'item'+id;
                                          }
                                   })

                                }
                          }

                  })
         }



                   return id ;
           }
           vm.takeNumber = function (data){
             if(typeof (data)  === 'string'){

               data = parseInt(data) ;

           }
   return data ;
         }

                function getContentUrl(){
                    if ( typeof vm.templateUrl == 'undefined' ) {
                        if (typeof  vm.type == 'undefined'){

                            return 'app/widgets/obtSection/obtSection.html';
                        }else{
                            var type = parseInt(vm.type, 10);
                           return 'app/widgets/obtSection/type_'+ type +'.html'

                        }
                    } else {
                        return vm.templateUrl;
                    }
                }

          

             
         

               

                if(vm.type === '9'){
                  // vm.desktop = screenSize.is('md, lg');
                  // vm.mobile = screenSize.is('xs, sm');

                     var tamponTabMobile =[];
                     var items = vm.data.gallery.slice(0);
                     var itemsMobile = items.slice(0);
                     console.log(items,itemsMobile,vm.data.gallery);
                     while(itemsMobile.length){
                         var item = itemsMobile.slice(0,1);
                         itemsMobile.splice(0,1);
                         tamponTabMobile.push(item) ;
                     }

                     vm.galtype9Mobile = tamponTabMobile;

                     var tamponTab =[];
                     var nbCol =  parseInt(vm.data.gallery_item_per_row);
                  //   var items = vm.data.gallery;
                     while(items.length){
                         var item = items.slice(0,nbCol);
                         items.splice(0,nbCol);
                         tamponTab.push(item) ;
                     }

                     vm.galtype9 = tamponTab;



                }


                if(vm.type === '7'){
                 
                    var tamponTab7 =[];
                    var tamponTab7Mobile =[];
                    var nbCol7 =  parseInt(vm.data.gallery_item_per_row);
                    var items = vm.data.gallery.slice(0);
                    var itemsMobile = items.slice(0);
                    while(items.length)
                    {
                        var item = items.slice(0,nbCol7);
                        items.splice(0,nbCol7);
                        tamponTab7.push(item) ;
                    }
                    vm.galtype7 = tamponTab7;
                    while(itemsMobile.length)
                    {
                        var item = itemsMobile.slice(0,1);
                        itemsMobile.splice(0,1);
                        tamponTab7Mobile.push(item) ;
                    }
                    vm.galtype7Mobile = tamponTab7Mobile;
                   
                }

            }
        };
       
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/obtSection/obtSection.directive.js
 ** module id = 191
 ** module chunks = 0
 **/